export default __webpack_public_path__ + "static/media/challenge-icon-positive.beeb2736.svg";